//import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
